module.exports = __webpack_public_path__ + "img/saizi4_QX.24bacbfe.png";